:host {
  --form-field-max-width: 594px;
  --form-field-min-width: initial;
  --form-field-with-floating-max-width: 400px;
  --form-field-label-custom-width: 182px;
  --chip-list-margin-top: calc(var(--spacer) * 2);
  --chip-list-width: 640px;
  --chip-list-max-height: 240px;
  --search-input-margin-top-right-left: calc(var(--spacer) / 2);
  --search-input-margin-bottom: calc(var(--spacer) / 2);
  --chip-theme-input-padding: 7px 0 7px calc(var(--spacer) * 1.5);
  --chip-max-width: calc(var(--spacer) * 18);
  --scrollable-container-max-height: 192px;
}

:host([hasSearchInput]) {
  --chip-list-max-height: 246px;
}

:host([themeInput]) {
  --form-field-max-width: initial;
  --form-field-min-width: 120px;
  --form-field-with-floating-max-width: 400px;
  --form-field-label-custom-width: 0;
  --chip-list-margin-top: 0;
  --chip-list-width: 649px;
  --chip-list-max-height: 100px;

  .chip-list {
    border: 1px solid var(--chart-100-pressed);
    border-radius: 4px;
    align-items: center;
    overflow-y: auto;
    height: unset;
    max-height: var(--chip-list-max-height);
    padding: 0;
  }

  &:host([label='']) gz-form-field,
  &:host([hasFloatingLabel]) gz-form-field {
    max-width: unset;
  }

  gz-form-field {
    margin-right: 0;
    margin-left: 0;
    --margin-bottom-wrapper: 0;
    min-width: var(--form-field-min-width);
    flex: 1;
  }

  gz-input {
    --input-border: none;
    --input-height: 30px;
    --input-padding: var(--chip-theme-input-padding);
  }

  .counter {
    margin-right: 0;
  }

  .input-list-container {
    display: flex;
    flex-direction: column;
  }

  gz-copy-to-clipboard {
    --btn-padding: 0 0 0 calc(var(--spacer) * 1.5);
    display: flex;
    align-items: flex-end;
  }

  &:host([disabled]) {
    .counter {
      opacity: 0.5;
    }
  }
}

gz-form-field {
  --margin-bottom-wrapper: 0;
}

gz-textarea {
  &::part(textarea) {
    padding-right: calc(4 * var(--spacer));
    resize: none;
  }
}

.no-results-string {
  margin-left: calc(var(--spacer) * 1.5);
}

.clear-button {
  position: absolute;
  top: calc(var(--spacer) / 2);
  right: calc(var(--spacer) / 2);
}

:host([themeInput][isInvalidChipForm]) {
  .chip-list {
    border-color: var(--red-layout-300-primary);
  }
}

:host([customFormSizing]) {
  gz-form-field {
    &::part(form-field-label) {
      min-width: 250px;
      max-width: 250px;
    }
  }

  .chip-list {
    padding-left: 70px;
  }
}

gz-form-field {
  margin-right: 12px;
  margin-left: calc(var(--spacer) / 2);
  max-width: var(--form-field-max-width);
  flex: 0 0 80%;

  &::part(form-field-label) {
    width: var(--form-field-label-custom-width);
    min-width: var(--form-field-label-custom-width);

    &:after {
      content: none;
    }
  }

  gz-input-error {
    max-width: 400px;
  }
}

:host([disabled]) {
  gz-form-field::part(form-field-label),
  .counter,
  .hint-text {
    opacity: 0.5;
  }

  .chip-list {
    border-color: var(--grey-layout-200-disabled);
  }
}

:host([hasFloatingLabel]) {
  gz-form-field {
    margin-left: 0;
  }
}

.chip-list {
  width: var(--chip-list-width);
  margin-top: var(--chip-list-margin-top);
  border: 1px solid var(--chart-100-pressed);
  border-radius: calc(var(--spacer) / 2);
  padding: calc(var(--spacer) / 2);
  align-items: flex-start;
  align-content: flex-start;
  max-height: var(--chip-list-max-height);
  flex-wrap: wrap;
  overflow-y: hidden;

  gz-chip {
    --content-max-width: var(--chip-list-width);
  }
}

.scrollable-container {
  width: 100%;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow: auto;
  height: fit-content;
  max-height: var(--scrollable-container-max-height);
}

.counter {
  margin-top: 6px;
  color: var(--body-text-arrows-400);
}

.actions {
  max-width: var(--chip-list-width);
  height: 21px;
}

gz-copy-to-clipboard {
  --btn-padding: 0 0 0 var(--spacer);
  width: fit-content;
}

.search-input {
  margin: var(--search-input-margin-top-right-left) var(--search-input-margin-top-right-left)
    var(--search-input-margin-bottom);
  height: fit-content;
}

:host([label='']),
:host([hasFloatingLabel]) {
  gz-form-field {
    max-width: var(--form-field-with-floating-max-width);
  }

  .chip-list {
    margin-left: unset;
  }
}

.hint-text {
  padding: 0px var(--spacer);
  color: var(--body-text-arrows-400);
  transition: opacity 100ms ease-in-out, transform 200ms ease-out;
  opacity: 0;
  transform-origin: center top;
  transform: translateY(-10%) scaleY(0);
  height: 0;
  padding-top: 0px;

  &.visible-hint {
    opacity: 1;
    transform: translateY(0) scaleY(1);
    height: unset;
    display: block;
    padding-top: 4px;
  }
}

.mt-05 {
  margin-top: calc(var(--spacer) / 2);
}
